import { DEFAULT_INTL_ACTIONS, useIntlConfigurationStoreCare, useIntlConfigurationStorePortal, useIntlConfigurationStoreWebshop, type IntlShapeWebshop } from "@akina/infra";

const useIntlCare = () => {
  const intl = useIntlConfigurationStoreCare(state => state.intl);
  if (!intl) return DEFAULT_INTL_ACTIONS;
  return intl;
};

const useIntlPortal = () => {
  const intl = useIntlConfigurationStorePortal(state => state.intl);
  if (!intl) return DEFAULT_INTL_ACTIONS;
  return intl;
};

const useIntlWebshop = (): IntlShapeWebshop => {
  const intl = useIntlConfigurationStoreWebshop(state => state.intl);
  if (!intl) return DEFAULT_INTL_ACTIONS;
  return intl;
};

export const getUseIntl = {
  care: useIntlCare,
  portal: useIntlPortal,
  webshop: useIntlWebshop
};
